module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"typekit":{"id":"sol3rjl"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"1","matomoUrl":"https://bout.matomo.cloud/","siteUrl":"https://www.bout.fi/","dev":true,"requireConsent":true,"requireCookieConsent":true},
    }]
